<template>
  <div class="c-popup">
    <div class="c-popup__close-btn" v-on:click="closePopup"></div>

    <card v-bind:title="title" v-bind:name="name" v-bind:number="number" v-bind:image="image"></card>

    <!-- <p class="c-popup__date">{{date}}</p> -->
    <h2 class="c-popup__header">{{header}}</h2>
    <div class="c-popup__content" v-html="content"></div>

    <button class="c-popup__terms-button" v-on:click="openTerms">{{termsButton}}</button>

    <div class="c-popup__terms" v-show="termsOpen">
      <div class="c-popup__close-btn" v-on:click="closeTerms"></div>
      <div v-html="terms"></div>
    </div>
    <!-- <a data-pat-id="123123" v-bind:href="ctaUrl" class="c-popup__cta">{{cta}}</a> -->
  </div>
</template>

<script>
import Vue from "vue"; // eslint-disable-line no-unused-vars
import { mapGetters } from "vuex";
import cardComponent from "./card.vue";

export default {
  components: {
    card: cardComponent
  },
  data: function() {
    return {
      isOpen: false,
      termsOpen: false
    };
  },
  computed: {
    ...mapGetters({
      messages: "getMessages",
      apiUrl: "getPromoApiUrl",
      brandId: "getBrandId",
      channel: "getChannel",
      sessionKey: "getSessionKey",
      isLoggedIn: "getLoggedIn"
    })
  },
  mounted: function() {
    this.checkPatButtons();
  },
  updated: function() {
    this.checkPatButtons();
  },
  methods: {
    closePopup: function() {
      this.termsOpen = false;
      this.$emit("closePopup");
    },
    closeTerms: function() {
      this.termsOpen = false;
    },
    openTerms: function() {
      this.termsOpen = true;
    },
    patGet: function(url, callback) {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          // console.debug('responseText:' + xmlhttp.responseText);
          try {
            var data = JSON.parse(xmlhttp.responseText);
          } catch (err) {
            // console.debug(err.message + " in " + xmlhttp.responseText);
            return;
          }
          callback(data);
        }
      };

      xmlhttp.open("GET", url, true);
      xmlhttp.send();
    },

    patPost: function(url, callback) {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          // console.debug('responseText:' + xmlhttp.responseText);
          try {
            var data = JSON.parse(xmlhttp.responseText);
          } catch (err) {
            // console.debug(err.message + " in " + xmlhttp.responseText);
            return;
          }
          callback(data);
        }
      };

      xmlhttp.open("POST", url, true);
      xmlhttp.send();
    },

    getPromoChild: function(parentId, callback) {
      const _this = this;

      this.patGet(
        this.apiUrl +
          "activePromos?productId=CASINO&brandId=" +
          _this.brandId +
          "&channel=" +
          _this.channel +
          "&lang=en_US&sessionKey=" +
          _this.sessionKey,
        function(data) {
          data.activePromos.forEach(function(promo, index) {
            let promoEnd = new Date(promo.promoEndDateTZ);
            let promoStart = new Date(promo.promoStartDateTZ);
            let today = new Date();

            if (promo.parentPromoId == parentId) {
              if (
                today.getTime() <= promoEnd.getTime() &&
                today.getTime() >= promoStart.getTime()
              ) {
                console.debug(promo.promoId);
                callback(promo.promoId);
              }
            }
          });
        }
      );
    },

    promoOptIn: function(patId, promoBtn) {
      const _this = this;

      this.patPost("/api/offerstatus/promos/" + patId, function(data) {
        if (data.status === "OPTED_IN") {
          let newInfo = document.createElement("div");
          newInfo.innerHTML = _this.messages["OPTED_IN"];
          newInfo.classList.add(
            "optin-" + patId,
            "optin-message",
            "optin-message-OPTED_IN"
          );

          promoBtn.parentNode.replaceChild(newInfo, promoBtn);
          setTimeout(function() {
            _this.promoOptions(patId);
          }, 100);
        }

        if (data.status === "EXPIRED") {
          let newInfo = document.createElement("div");
          newInfo.innerHTML = _this.messages["EXPIRED"];
          newInfo.classList.add(
            "optin-" + patId,
            "optin-error",
            "optin-error-EXPIRED"
          );
          promoBtn.parentNode.replaceChild(newInfo, promoBtn);
        }
      });
    },

    checkPromoStatus(promoBtn) {
      const _this = this;
      this.getPromoChild(promoBtn.dataset.patId, function(childPatId) {
        _this.patGet("/api/offerstatus/promos/" + childPatId, function(data) {
          const promoStatus = data.status;

          if (promoStatus === "OFFERED") {
            promoBtn.addEventListener("click", function() {
              _this.promoOptIn(childPatId, promoBtn);
            });
          }

          if (
            ["OPTED_IN", "NOT_OFFERED", "INVALID", "EXPIRED"].includes(
              promoStatus
            )
          ) {
            let newInfo = document.createElement("div");
            newInfo.innerHTML = _this.messages[promoStatus];
            newInfo.classList.add(
              "optin-" + childPatId,
              "optin-message",
              "optin-message-" + promoStatus
            );

            promoBtn.parentNode.replaceChild(newInfo, promoBtn);

            if (promoStatus === "OPTED_IN") {
              setTimeout(function() {
                _this.promoOptions(childPatId);
              }, 100);
            }
          }
        });
      });
    },

    promoOptions: function(patId) {
      const _this = this;
      this.patGet(
        _this.apiUrl +
          "playerPromoResponse?promoId=" +
          patId +
          "&productId=CASINO&brandId=" +
          _this.brandId +
          "&channel=" +
          _this.channel +
          "&lang=en_US&sessionKey=" +
          _this.sessionKey,
        function(data) {
          if (data.promoType === "SCRATCH_CARD") {
            let optinStatus = document.querySelector(".optin-" + patId);

            let newResponseCardsStatus = document.createElement("table");

            newResponseCardsStatus.innerHTML =
              "<tr><td>Number of cards accumulated to date: </td> <td>" +
              data.noOfCardsThisPlayerWon +
              "</td></tr>" +
              '<tr><td>Prize(s) won to date:</td><td><div class="prizes-' +
              patId +
              '">' +
              // data.totalNoOfCardsAwarded +
              "</td></tr>";
            newResponseCardsStatus.appendAfter(optinStatus);

            Object.keys(data.prizeSummary).forEach(key => {
              let prizesNo = document.createElement("div");
              prizesNo.innerHTML =
                "<span>" +
                key +
                ': </span><span class="val">' +
                data.prizeSummary[key] +
                "</span> <br />";
              document.querySelector(".prizes-" + patId).appendChild(prizesNo);
            });

            if (data.scratchCardList.length > 0) {
              let newResponseCards = document.createElement("ul");
              newResponseCards.classList.add("scratchcards", "cards-" + patId);
              newResponseCards.appendAfter(optinStatus);

              Object.keys(data.scratchCardList).forEach(key => {
                let cardItem = document.createElement("li");
                cardItem.innerHTML =
                  '<a class="click-card-item" href="#" data-promo-id="' +
                  patId +
                  '" data-card-id="' +
                  data.scratchCardList[key].playerAwardId +
                  '"><img src="' +
                  data.scratchCardList[key].unClickedURL +
                  '" /><span>Click me</span></a>';
                document.querySelector(".cards-" + patId).appendChild(cardItem);
              });
              const cards = newResponseCards.querySelectorAll(
                "a.click-card-item"
              );

              cards.forEach(function(card) {
                card.addEventListener("click", function(e) {
                  e.preventDefault();
                  _this.cardReveal(card);
                });
              });
            }
          }

          if (data.promoType === "LEADER_BOARD") {
            let optinStatus = document.querySelector(".optin-" + patId);

            let newResponseCardsStatus = document.createElement("table");

            newResponseCardsStatus.innerHTML =
              "<tr><td>Current rank: </td> <td>" +
              data.detailMap.REGULAR.rank +
              "</td></tr>" +
              '<tr><td>leader board points earned so far:</td><td><div class="prizes-' +
              patId +
              '">' +
              data.detailMap.REGULAR.pointsEarned +
              "</td></tr>";
            newResponseCardsStatus.appendAfter(optinStatus);
          }
        }
      );
    },

    cardReveal: function(card) {
      const _this = this;
      this.patPost(
        _this.apiUrl +
          "clickCard?promoId=" +
          card.dataset.promoId +
          "&cardId=" +
          card.dataset.cardId +
          "&channel=" +
          _this.channel +
          "&lang=en_US&sessionKey=" +
          _this.sessionKey,
        function(data) {
          Object.keys(data.ClickResponse).forEach(key => {
            //  console.debug(data.ClickResponse[key].playerAwardId)
            if (
              data.ClickResponse[key].playerAwardId ===
              parseInt(card.dataset.cardId)
            ) {
              let cardInfo = document.createElement("div");
              cardInfo.innerHTML =
                "<span>" +
                data.ClickResponse[key].awardDescription +
                '</span> <img src="' +
                data.ClickResponse[key].clickedURL +
                '" />';
              card.parentNode.replaceChild(cardInfo, card);
            }
          });
        }
      );
    },
    checkPatButtons() {
      const _this = this;
      const optInPromos = document.querySelectorAll("[data-pat-id]");

      // let userstatus = "_|User.LoggedIn|_";

      optInPromos.forEach(function(promoBtn) {
        if (_this.isLoggedIn) {
          _this.checkPromoStatus(promoBtn);
        } else {
          promoBtn.addEventListener("click", function() {
            if (typeof $ === "function") {
              if ($.bwin) {
                $.bwin.CenteredLogin.overlay.loadCenteredLogin(
                  window.location.href
                );
              }
            } else {
              window.location.href =
                location.href.split("/promo/")[0] +
                "/labelhost/login?rurl=https://promo.m.sportingbet.com/en/promo/s/p/casino/casinoworld";
            }
          });
        }
      });
    }
  },
  props: [
    "image",
    "title",
    "name",
    "number",
    "date",
    "header",
    "content",
    "terms",
    "termsButton"
  ]
};
</script>




// WEBPACK FOOTER //
// src/components/popup.vue